export class PdfGenerateCtrl {
    downloadName = 'file.pdf';
    pdfLoading = false;
    buttonText = "Generate PDF";
    downloadUrl = null;

    constructor($scope, $http, notify) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;
        this.notify = notify;
    }

    initialize(pdfGenerated) {
        if (pdfGenerated) {
            this.buttonText = "Download PDF";
        } else {
            this.buttonText = "Generate PDF";
        }
    }

    handleButtonClick(e, url) {
        if (this.buttonText === "Generate PDF") {
            this.generatePdf(e, url);
        } else if (this.buttonText === "Download PDF") {
            this.downloadPdf(e, url);
        }
    }

    generatePdf(e, url) {
        if (url && url !== '') {
            this.pdfLoading = true;
            this.buttonText = "Generating...";

            this.$scope
                .basicHttpConfigProcess({
                    url: url,
                    method: 'GET',
                    responseType: 'json',
                })
                .then((response) => {
                    this.pdfLoading = false;
                    if (response.data && response.data.success) {
                        this.buttonText = "Download PDF";
                        this.downloadUrl = response.data.download_url;
                        this.downloadName = response.data.file_name;

                    } else {
                        this.buttonText = "Generate PDF";
                    }
                })
                .catch((error) => {
                    this.pdfLoading = false;
                    this.buttonText = "Generate PDF";
                    console.error("Error generating PDF:", error);
                });

        }
    }

    downloadPdf(e, url) {
        let adjustedUrl = this.downloadUrl ? this.downloadUrl : url;
        if (adjustedUrl && adjustedUrl !== '') {
            this.$scope
                .basicHttpConfigProcess({
                    url: adjustedUrl,
                    method: 'GET',
                    responseType: 'blob',
                })
                .then((response) => {
                    if (response && response.data) {
                        const contentDisposition = response.headers('Content-Disposition');
                        let filename = this.downloadName || 'file.pdf';

                        if (contentDisposition) {
                            const filenameMatch = contentDisposition.match(/filename="?([^"]+)"?/);
                            if (filenameMatch && filenameMatch[1]) {
                                filename = filenameMatch[1];
                            }
                        }

                        const blob = new Blob([response.data], {type: 'application/pdf'});
                        const downloadUrl = window.URL.createObjectURL(blob);

                        const link = document.createElement('a');
                        link.href = downloadUrl;
                        link.download = filename;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);

                        window.URL.revokeObjectURL(downloadUrl);
                    }
                })
                .catch((error) => {
                    this.pdfLoading = false;
                    console.error('Error downloading PDF:', error);
                });
        }
    }
}
